export class AiConstants
{
    public static Application: string = 'AiApi';
    public static BaseUrl = 'ai';
    public static DefaultUrl = `/${AiConstants.BaseUrl}`;
}
